import { render, staticRenderFns } from "./orderfrezee.vue?vue&type=template&id=1e41dad4&scoped=true"
import script from "./orderfrezee.vue?vue&type=script&lang=js"
export * from "./orderfrezee.vue?vue&type=script&lang=js"
import style0 from "./orderfrezee.vue?vue&type=style&index=0&id=1e41dad4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e41dad4",
  null
  
)

export default component.exports